import { build } from "../../tools/ConfigBuilder";
import { lazy } from "react";

export default build([
	{
		path: "/profile/carriers/:carrierId/declined-transactions",
		component: lazy(() => import("./DeclinedTransactionsPage")),
	},
]);
